<template>
    <div>
        <div class="card border-primary mb-3">
            <div class="card-body">
                <div class="row">
                    <div class="form-group col-sm-12 col-md-6">
                        <label class="font-weight-bold required">{{$t('rankingCriteria.editor.type')}}</label>
                        <kendo-dropdownlist v-model="model.constraintType"
                                            :data-source="constraintTypes"
                                            :data-text-field=" isEnVersion ? 'textEn' : 'text'"
                                            :data-value-field="'value'"
                                            :clear-button="true"
                                            :filter="'contains'"
                                            :popup="popup"
                                            :optionLabel="$t('choose')"
                                            :name="'constraintType' + _uid"
                                            :id="'constraintType' + _uid"
                                            v-validate="'required'"
                                            @change="onConstraintTypeChange"
                                            :data-vv-as="$t('rankingCriteria.editor.type')"
                                            :disabled="readonly"
                                            :height="500"
                                            style="width:100%">
                        </kendo-dropdownlist>
                        <span class="text-danger col-12" v-if="errors.has('constraintType' + _uid)">{{ errors.first('constraintType' + _uid) }}</span>
                    </div>

                    <div class="form-group col-sm-12 col-md-6">
                        <div class="row">
                            <div v-if="model.constraintType" class="col-sm-12" :class="model.evaluationCriteriaType == evaluationCriteriaType.Evaluation ? 'col-md-8' : 'col-md-12'">
                                <div>
                                    <label class="font-weight-bold required">{{$t('rankingCriteria.editor.kind')}}</label>
                                    <kendo-dropdownlist v-model="model.evaluationCriteriaType"
                                                        :data-source="evaluationCriteriaTypes"
                                                        :data-text-field=" isEnVersion ? 'textEn' : 'text'"
                                                        :data-value-field="'value'"
                                                        :clear-button="true"
                                                        :filter="'contains'"
                                                        :popup="popup"
                                                        :optionLabel="$t('choose')"
                                                        :name="'evaluationCriteriaType' + _uid"
                                                        :id="'evaluationCriteriaType' + _uid"
                                                        v-validate="'required'"
                                                        @change="onEvaluationCriteriaTypeChange"
                                                        :data-vv-as="$t('rankingCriteria.editor.kind')"
                                                        :disabled="readonly"
                                                        :height="500"
                                                        style="width:100%">
                                    </kendo-dropdownlist>
                                </div>
                                <span class="text-danger col-12" v-if="errors.has('evaluationCriteriaType' + _uid)">{{ errors.first('evaluationCriteriaType' + _uid) }}</span>
                            </div>

                            <div v-if="model.evaluationCriteriaType == evaluationCriteriaType.Evaluation" class="col-sm-12 col-md-4">
                                <label class="font-weight-bold required">{{$t('rankingCriteria.editor.score')}}</label>
                                <input type="number" min="0"
                                       class="form-control"
                                       v-model="model.score"
                                       :name="'score' + _uid"
                                       :id="'score' + _uid"
                                       :disabled="readonly"
                                       v-validate="'required'"
                                       :data-vv-as="$t('rankingCriteria.editor.score')" />
                                <span class="text-danger col-12" v-if="errors.has('score' + _uid)">{{ errors.first('score' + _uid) }}</span>
                            </div>

                        </div>
                    </div>

                    <div class="form-group col-sm-12 col-md-6" v-if="showCount">
                        <div class="m-2">
                            <vs-checkbox v-model="model.isCurrentYear"
                                         :name="'isCurrentYear' + _uid"
                                         :id="'isCurrentYear' + _uid"
                                         :disabled="readonly"
                                         style="justify-content: flex-start !important">
                                {{ $t('rankingCriteria.editor.isCurrentYear') }}
                            </vs-checkbox>
                        </div>
                        <div v-if="!model.isCurrentYear">
                            <DateTimeRange ref="formToDateTimeRange"
                                           :startTime.sync="model.startDateUtc"
                                           :endTime.sync="model.endDateUtc"
                                           :format="dateFormat"
                                           :showTime="false"
                                           :startTitle="'rankingCriteria.editor.from'"
                                           :endTitle="'rankingCriteria.editor.to'"
                                           :convertDateToUtc="false"
                                           :bindPopup="true"
                                           :popupContainerId="'#constraint-container'"
                                           :readonly="readonly">
                            </DateTimeRange>
                        </div>

                    </div>

                    <div class="form-group col-sm-12 col-md-6" v-if="showCount">
                        <div class="row m-2">
                            <div class="col-sm-12 col-md-6">
                                <div class="min-max-type">
                                    <div class="form-check m-2">
                                        <input class="form-check-input" type="radio"
                                               :disabled="readonly"
                                               :name="'inlineRadioOptions' + _uid"
                                               id="inlineRadio1" value="1"
                                               v-model="model.minMaxType">
                                        <label class="form-check-label" for="inlineRadio1">{{$t('rankingCriteria.editor.min')}}</label>
                                    </div>
                                    <div class="form-check m-2">
                                        <input class="form-check-input" type="radio"
                                               :disabled="readonly"
                                               :name="'inlineRadioOptions' + _uid" id="inlineRadio2" value="2" v-model="model.minMaxType">
                                        <label class="form-check-label" for="inlineRadio2">{{$t('rankingCriteria.editor.max')}}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6">
                                <label class="font-weight-bold required">{{$t('rankingCriteria.editor.count')}}</label>
                                <input type="number" min="1"
                                       class="form-control"
                                       v-model="model.count"
                                       :name="'count' + _uid"
                                       :id="'count' + _uid"
                                       v-validate="'required'"
                                       :disabled="readonly"
                                       :data-vv-as="$t('rankingCriteria.editor.count')" />
                                <span class="text-danger col-12" v-if="errors.has('count' + _uid)">{{ errors.first('count' + _uid) }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="form-group col-sm-12 col-md-6" v-if="model.constraintType == rankingConstraintType.ParticipatesInOverlappingEvent">
                        <vs-checkbox v-model="model.notParticipatesInOverlappingEvent"
                                     :name="'notParticipatesInOverlappingEvent' + _uid"
                                     :id="'notParticipatesInOverlappingEvent' + _uid"
                                     :disabled="model.notParticipatesInOverlappingEvent || readonly"
                                     style="justify-content: flex-start !important">
                            {{ $t('rankingCriteria.editor.notParticipatesInOverlappingEvent') }}
                        </vs-checkbox>
                    </div>

                    <div class="form-group col-sm-12 col-md-6" v-if="model.constraintType == rankingConstraintType.ConsentOfTheManager">
                        <vs-checkbox v-model="model.hasConsentOfTheManager"
                                     :name="'hasConsentOfTheManager' + _uid"
                                     :id="'hasConsentOfTheManager' + _uid"
                                     :disabled="model.hasConsentOfTheManager || readonly"
                                     style="justify-content: flex-start !important">
                            {{ $t('rankingCriteria.editor.hasConsentOfTheManager') }}
                        </vs-checkbox>
                    </div>

                    <div class="form-group col-sm-12 col-md-6" v-if="showAudience">
                        <label class="font-weight-bold required">{{$t('rankingCriteria.editor.audience')}}</label>
                        <input type="text"
                               class="form-control"
                               v-model="model.filterValue"
                               :name="'audience' + _uid"
                               :id="'audience' + _uid"
                               v-validate="'required'"
                               :disabled="readonly"
                               :data-vv-as="$t('rankingCriteria.editor.audience')" />
                        <span class="text-danger col-12" v-if="errors.has('audience' + _uid)">{{ errors.first('audience' + _uid) }}</span>
                    </div>

                    <div class="form-group col-sm-12 col-md-6" v-if="eventId && (model.constraintType == rankingConstraintType.ConsentOfTheManager
                         || model.constraintType == rankingConstraintType.OutsideTheTargetAudience)">
                        <label class="font-weight-bold">{{$t('rankingCriteria.editor.searchFieldName')}}</label>
                        <div v-if="readonly">
                            <input type="text"
                                   readonly
                                   class="form-control"
                                   v-model="model.searchFieldName"
                                   :name="'searchFieldName' + _uid"
                                   :id="'searchFieldName' + _uid" />
                        </div>
                        <div v-else>
                            <kendo-dropdownlist v-model="model.searchFieldName"
                                                :data-source="formFieldsNames"
                                                :data-text-field=" isEnVersion ? 'textEn' : 'text'"
                                                :data-value-field="'text'"
                                                :clear-button="true"
                                                :popup="popup"
                                                :filter="'contains'"
                                                :optionLabel="$t('choose')"
                                                :name="'searchFieldName' + _uid"
                                                :id="'searchFieldName' + _uid"
                                                :disabled="readonly"
                                                :height="500"
                                                style="width:100%"
                                                aria-describedby="searchFieldNameHelp">
                            </kendo-dropdownlist>
                        </div>
                        <small id="searchFieldNameHelp" class="form-text text-muted">
                            {{$t('rankingCriteria.editor.help.searchFieldName')}}
                        </small>
                    </div>
                </div>

                <div>
                    <button v-if="!readonly" type="button" class="btn btn-sm btn-danger" @click.stop="deleteConstraint"><i class="far fa-trash-alt mr-2"></i>{{ $t('buttons.delete.btnText')}}</button>
                </div>
            </div>

            <div class="card-footer text-muted" v-if="model.fulfillment">
                <span class="m-1"><strong>{{ model.fulfillment }}</strong></span>
            </div>
        </div>
    </div>
</template>

<script>
    import { RankingConstraint } from '../../models/models';
    import { EvaluationCriteriaType, RankingConstraintType } from '../../models/enums';
    import DateTimeRange from '../../components/dateTimeRange/DateTimeRange_new';
    import dynamicFormService from '../../services/dynamicForm.service';
    import { mapGetters } from 'vuex';

    export default {
        inject: ['$validator'],
        props: {
            value: {
                type: [Object, RankingConstraint],
                required: true
            },
            readonly: {
                type: Boolean,
                default: true
            },
            eventId: {
                type: [Number, String]
            }
        },
        components: {
            DateTimeRange
        },
        created() {
        },
        data() {
            return {
                model: this.value,
                evaluationCriteriaType: EvaluationCriteriaType,
                rankingConstraintType: RankingConstraintType,
                formFieldsNames: {},
                popup: {
                    appendTo: $("#constraint-container")
                }
            }
        },
        methods: {
            deleteConstraint() {
                if (this.model) {
                    this.$emit("delete", this.model);
                }
            },
            onConstraintTypeChange(e) {
                const idx = e.sender.selectedIndex - 1;
                this.model.code = idx >= 0
                    ? e.sender.dataSource.view()[idx]['code']
                    : '';
                if (idx >= 0) {
                    if (!this.showCount) {
                        this.model.minMaxType = '';
                    }
                }

                if (e.sender.selectedIndex === this.rankingConstraintType.ParticipatesInOverlappingEvent) {
                    if (!this.model.notParticipatesInOverlappingEvent) {
                        this.model.notParticipatesInOverlappingEvent = true;
                    }
                }

                if (e.sender.selectedIndex === this.rankingConstraintType.ConsentOfTheManager) {
                    if (!this.model.hasConsentOfTheManager) {
                        this.model.hasConsentOfTheManager = true;
                    }
                }
            },
            onEvaluationCriteriaTypeChange(e) {
                const idx = e.sender.selectedIndex - 1;
                this.model.evaluationCriteriaCode = idx >= 0
                    ? e.sender.dataSource.view()[idx]['code']
                    : '';
            },
            loadFormFieldsNames() {
                if (!this.eventId) {
                    return;
                }

                dynamicFormService
                    .getParticipationRequestFormFieldsNames(this.eventId)
                    .then(response => {
                        if (response.data) {
                            this.formFieldsNames = response.data;
                        }
                    })
            }
        },
        computed: {
            ...mapGetters(['isEnVersion', 'evaluationCriteriaTypes', 'constraintTypes', 'authToken', 'dateFormat', 'dateTimeFormat']),
            showCount() {
                const source = [this.rankingConstraintType.NumberOfParticipation, this.rankingConstraintType.NumberOfParticipationRequests, this.rankingConstraintType.NumberOfRefusalsToParticipate]
                const type = Number(this.model.constraintType);

                return !isNaN(type) && source.includes(type);
            },
            showAudience() {
                const source = [this.rankingConstraintType.OutsideTheTargetAudience]
                const type = Number(this.model.constraintType);

                return !isNaN(type) && source.includes(type);
            }

        },
        mounted() {
            this.loadFormFieldsNames();
        },
        watch: {
            value: function (val) {
                if (val) {
                    this.model = new RankingConstraint(this.value);
                }
            }
        }
    }
</script>

<style scoped>
    input[readonly] {
        background-color: whitesmoke;
    }

    textarea[readonly] {
        background-color: whitesmoke;
    }
</style>
